import React from "react";
//#region types
import { WintFormConnect } from "models/propTypes/wintFormPropsTypes";
import { ReferencePersonStepProps } from "models/propTypes/customerImportPropTypes";
import { TranslationKeys } from "translations";
import { CustomerFormTypes } from "models/formTypes";
//#endregion
//#region components
import { Description, EditableTable, FormFieldLayout, SelectInput, WizardSection } from "components/common/wintForms";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { Grid } from "@mui/material";

const ReferencePersonStep: React.FC<ReferencePersonStepProps> = ({
  connect,
  headersObject,
  submitted,
  wizardProps,
  values,
}) => {
  return (
    <WizardSection header={TranslationKeys.Common.Reference} submitted={submitted} wizardProps={wizardProps}>
      <FormFieldLayout
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ReferencePerson)}
        direction="vertical"
      >
        <Grid container marginTop={-1.5}>
          <Description horizontal>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ImportReferencePersonDescription)}
          </Description>
        </Grid>

        <Grid container direction="column" marginTop={3} marginBottom={1}>
          <Description horizontal>
            {LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Customer.ImportReferencePersonNameDescription
            )}
          </Description>
          <Description horizontal>
            {LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Customer.ImportReferencePersonIdDescription
            )}
          </Description>
          <Description horizontal>
            {LocalizationHelperInstance.getFormattedMessage(
              TranslationKeys.Customer.ImportReferencePersonIsDefaultDescription
            )}
          </Description>
        </Grid>
      </FormFieldLayout>
      <EditableTable<CustomerFormTypes.ReferencePersonImport>
        connect={connect as WintFormConnect<any>}
        name={"referencePersons"}
        value={values.referencePersons ?? []}
        isCompactTable
        fields={{
          nameColumn: {
            Component: SelectInput,
            extraProps: {
              label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ReferencePersonName),
              items: headersObject,
              optional: true,
            },
          },
          mailColumn: {
            Component: SelectInput,
            extraProps: {
              label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ReferencePersonEmail),
              items: headersObject,
              optional: true,
            },
          },
          phoneColumn: {
            Component: SelectInput,
            extraProps: {
              label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ReferencePersonPhone),
              items: headersObject,
              optional: true,
            },
          },
          identifierColumn: {
            Component: SelectInput,
            extraProps: {
              label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ReferencePersonId),
              items: headersObject,
              optional: true,
            },
          },
          isDefaultColumn: {
            Component: SelectInput,
            extraProps: {
              label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ReferencePersonDefault),
              items: headersObject,
              optional: true,
            },
          },
        }}
        idField="id"
        defaultRow={{}}
      />
    </WizardSection>
  );
};

export default ReferencePersonStep;
